import { useEffect, useState } from 'react';

const CONSENT_KEY = 'medcodes_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hasConsent = localStorage.getItem(CONSENT_KEY) === 'accepted';
    setVisible(!hasConsent);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="cookie-consent" role="dialog" aria-live="polite" aria-label="Avis sur les témoins">
      <div className="cookie-consent-content">
        <p className="cookie-consent-text">
          Medcodes utilise des témoins (cookies) strictement nécessaires au fonctionnement
          de l'application, notamment pour maintenir votre session de connexion. Aucune
          donnée personnelle n'est stockée à des fins publicitaires ou de suivi.{' '}
          <a href="/privacy">En savoir plus</a>.
        </p>
        <button type="button" className="btn btn-primary cookie-consent-btn" onClick={handleAccept}>
          OK
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
